// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Global state object type definition.
 * @author James Reid
 */

// @ts-check

// @@imports-types
/* eslint-disable no-unused-vars -- Types only used in comments. */
import { Application, Container } from "pixi.js"
import {
    Deck,
    DeckOption,
    Edge,
    EpdmCalculator,
    Stock,
    Vector2D
} from "../../../package/index.js"
import { LoadedSpritesheet } from "./LoadedSpritesheet.js"
import { deckRedrawCb } from "./callbacks.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/**
 * 
 * @typedef {object} DeckEditor
 * @property {Deck} deck
 * @property {Application} app
 * @property {Container} container
 * @property {deckRedrawCb} redraw
 * @property {Vector2D} anchor 
 * @property {Vector2D} targetAnchor
 * @property {number} width
 * @property {number} height
 * @property {number} scale
 * @property {number} targetScale
 * @property {Edge} selectedEdge
 * @property {boolean} dragging
 */

/**
 * change name to CalculatorState 
 * @typedef {object} State
 * @property {EpdmCalculator?} epdmCalculator
 * @property {Stock} stock
 * @property {DeckOption?} deckOption
 * @property {DeckEditor} deckEditor
 * @property {LoadedSpritesheet?} spritesheet
 * @property {object[]} steps
 * @property {number} currentStep
 */

// @@exports
/**
 * @type {DeckEditor}
 * @ignore
 */
export let DeckEditor

/**
 * @type {State}
 * @ignore
 */
export let State
